export default __webpack_public_path__ + "static/assets/3d71dd48613895c4ed9d8f070cfbf32b.jpg";